import { ref, watch } from 'vue'

const consentGiven = ref(localStorage.getItem('gdpr_consent') ?? null)

function giveConsent() {
  localStorage.setItem('gdpr_consent', 'true')
  consentGiven.value = true
}

function revokeConsent() {
  localStorage.setItem('gdpr_consent', 'false')
  consentGiven.value = false
}

function removeConsent() {
  localStorage.removeItem('gdpr_consent')
  consentGiven.value = null
}

watch(
  consentGiven,
  newValue => {
    if (String(newValue) == 'true') {
      loadTrackingScripts()
    } else if (String(newValue) == 'false' || newValue == undefined ||newValue == null) {      
      removeTrackingScripts()
    }
  },
  { immediate: true }
)

function loadTrackingScripts() {
  // Load Google Analytics
  const gaScript = document.createElement('script')
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=G-R9XPBJE9GJ`
  gaScript.async = true
  document.head.appendChild(gaScript)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', 'G-R9XPBJE9GJ')

  // Load Hotjar
  const hotjarScript = document.createElement('script')
  hotjarScript.innerHTML = `
       (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:5208952,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `
  document.head.appendChild(hotjarScript)
}

function removeTrackingScripts() {
  // Remove Google Analytics
  const gaScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]')
  if (gaScript) {
    gaScript.remove()
  }
  window.dataLayer = []

  // Remove Hotjar
  const hotjarScript = document.querySelector('script[src*="static.hotjar.com/c/hotjar-"]')
  if (hotjarScript) {
    hotjarScript.remove()
  }
  window.hj =
    window.hj ||
    function () {
      ;(window.hj.q = window.hj.q || []).push(arguments)
    }
  window.hj.q = []
}

export const useCookieConsent = () => {
  return { consentGiven, giveConsent, revokeConsent, removeConsent }
}
